import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, ShoppingCart, Layers, Calculator, Users, Crown,
  Network, Trophy, TrendingUp, Wallet, X, PieChart,
} from "lucide-react";

const NAV = [
  { to: "/overview", label: "Command Center", icon: LayoutDashboard, id: "overview" },
  { to: "/buy", label: "Buy & Auto-Stake", icon: ShoppingCart, id: "buy" },
  { to: "/tiers", label: "Staking Tiers", icon: Layers, id: "tiers" },
  { to: "/calculator", label: "Rewards Calculator", icon: Calculator, id: "calculator" },
  { to: "/referral", label: "Referral Hub", icon: Users, id: "referral" },
  { to: "/ranks", label: "Rank Hierarchy", icon: Crown, id: "ranks" },
  { to: "/levels", label: "Override Income", icon: Network, id: "levels" },
  { to: "/shares", label: "Share System", icon: PieChart, id: "shares" },
  { to: "/pools", label: "Croc Pools", icon: Trophy, id: "pools" },
  { to: "/prediction", label: "Prediction Market", icon: TrendingUp, id: "prediction" },
  { to: "/withdraw", label: "Withdraw & Burn", icon: Wallet, id: "withdraw" },
];

export default function Sidebar({ open, onClose }) {
  return (
    <>
      {open && <div className="fixed inset-0 z-40 bg-black/60 lg:hidden" onClick={onClose} />}
      <aside
        className={`fixed lg:sticky top-0 lg:top-16 z-50 lg:z-0 h-full lg:h-[calc(100vh-4rem)] w-72 shrink-0
        bg-[#080D0A] lg:bg-transparent border-r border-white/10 p-4 overflow-y-auto transition-transform
        ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
      >
        <div className="flex items-center justify-between lg:hidden mb-4">
          <span className="font-display font-black text-white">CROC PROTOCOL</span>
          <button onClick={onClose} className="text-white"><X className="w-5 h-5" /></button>
        </div>
        <nav className="space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              onClick={onClose}
              data-testid={`nav-${n.id}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-3.5 py-2.5 text-sm transition-all ${
                  isActive
                    ? "bg-[#1CFD4C]/12 text-[#1CFD4C] border border-[#1CFD4C]/30 glow-gold"
                    : "text-muted-foreground hover:text-white hover:bg-white/5 border border-transparent"
                }`
              }
            >
              <n.icon className="w-4.5 h-4.5 w-[18px] h-[18px]" />
              <span className="font-medium">{n.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="mt-6 croc-panel p-4">
          <div className="text-[10px] uppercase tracking-widest gold-text mb-1">Hard Cap</div>
          <div className="font-num font-bold text-white">1,000,000,000 CROC</div>
          <p className="text-[11px] text-muted-foreground mt-2 leading-relaxed">
            Rewards paid only from realized protocol revenue. Yield is variable, capped at 0.5%/day.
          </p>
        </div>
      </aside>
    </>
  );
}
